import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-md shadow-sm w-full overflow-hidden border" }
const _hoisted_2 = {
  id: "header",
  class: "bg-gray-50 border-b"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createElementVNode("div", {
      ref: "containerScroll",
      class: _normalizeClass(`${_ctx.height} overflow-auto scroll-style bg-white`),
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 34)
  ]))
}